// extracted by mini-css-extract-plugin
export default {"copyIcon":"styles_copyIcon__tN2Qh"};